/**
 * Environment Configuration
 * Centralizovaná validace a načítání environment proměnných
 */

/**
 * Validuje, že všechny požadované env proměnné jsou nastavené
 * @param {string[]} requiredVars - Seznam požadovaných proměnných
 * @throws {Error} Pokud některá proměnná chybí
 */
export const validateEnv = (requiredVars = []) => {
  const missing = requiredVars.filter(varName => !process.env[varName]);
  
  if (missing.length > 0) {
    throw new Error(
      `Missing required environment variables: ${missing.join(', ')}\n` +
      `Please check your .env.local file or set these variables.`
    );
  }
};

/**
 * Načte environment proměnnou s fallback hodnotou
 * @param {string} key - Název proměnné
 * @param {string} defaultValue - Výchozí hodnota
 * @returns {string}
 */
export const getEnv = (key, defaultValue = '') => {
  return process.env[key] || defaultValue;
};

/**
 * Načte boolean environment proměnnou
 * @param {string} key - Název proměnné
 * @param {boolean} defaultValue - Výchozí hodnota
 * @returns {boolean}
 */
export const getEnvBool = (key, defaultValue = false) => {
  const value = process.env[key];
  if (!value) return defaultValue;
  return value.toLowerCase() === 'true' || value === '1';
};

// API Configuration
export const API_BASE_URL = getEnv('REACT_APP_API_BASE_URL', getEnv('REACT_APP_API_URL', 'http://localhost:8000'));
export const BASE_URL = getEnv('REACT_APP_BASE_URL', 'http://localhost:3000');

// Analytics
export const GA_ID = getEnv('REACT_APP_GA_ID', '');
export const PLAUSIBLE_DOMAIN = getEnv('REACT_APP_PLAUSIBLE_DOMAIN', '');

// Error Tracking
export const SENTRY_DSN = getEnv('REACT_APP_SENTRY_DSN', '');
export const SENTRY_ENVIRONMENT = getEnv('REACT_APP_SENTRY_ENVIRONMENT', process.env.NODE_ENV || 'development');

// Feature Flags
export const ENABLE_ANALYTICS = getEnvBool('REACT_APP_ENABLE_ANALYTICS', true);
export const ENABLE_ERROR_TRACKING = getEnvBool('REACT_APP_ENABLE_ERROR_TRACKING', false);

// Validace kritických proměnných pouze v produkci
if (process.env.NODE_ENV === 'production') {
  try {
    validateEnv(['REACT_APP_API_BASE_URL', 'REACT_APP_BASE_URL']);
  } catch (error) {
    console.error('Environment validation failed:', error.message);
    // V produkci by mělo být throw, ale pro teď jen logujeme
  }
}

